type iUserType= Readonly<"TEACHER" | "STUDENT" | "PARENT">
export default class CommonUser{
    /**
     * @type {string}
     * @memberof CommonUser
     * @name 姓名
     */
    public fullName:string;
    /**
     * @type {string}
     * @memberof CommonUser
     * @name no
     */
    public no:string;
    /**
     * @type {string}
     * @memberof CommonUser
     * @name 用户ID
     */
    public userId:string;
    /**
     * @type {string}
     * @memberof CommonUser
     * @name 用户姓名
     */
    public userName:string;
    /**
     * @type {T}
     * @memberof CommonUser
     * @name 用户类型
     */
    public userType:iUserType;
    /**
     * @type {string}
     * @memberof CommonUser
     * @name 部门ID
     */
    public departmentId:string;
    /**
     * @type {string}
     * @memberof CommonUser
     * @name 部门名称
     */
    public departmentName:string;
    /**
     * @type {string}
     * @memberof CommonUser
     * @name 部门类型
     */
    public departmentType:string;
    /**
     * @type {string}
     * @memberof CommonUser
     * @name 用于显示的部门名称
     */
    public displayDepartment:string;
    constructor({
        fullName = '',
        no = '',
        userId = '',
        userName = '',
        userType = '', 
        departmentId = '',
        departmentName = '',
        departmentType = '',
        displayDepartment = ''
    } = {}) {
        this.fullName = fullName
        this.no = no
        this.userId = userId
        this.userName = userName
        this.userType = userType as iUserType
        this.departmentId = departmentId
        this.departmentName = departmentName
        this.departmentType = departmentType
        this.displayDepartment = displayDepartment
    }
}